import { createTheme } from '@mui/material/styles';
import '@mui/x-date-pickers/themeAugmentation';

import lelyTokenPrimitives from './lelyTokenPrimitives.module.scss';
import { getMuiComponents } from './componentOverrides';
import { parsePx } from './muiUtils';

import {
  LelyBackgroundColorLight,
  LelyTextColorLight,
  LelyBorderColorLight,
  LelyBorderRadius,
  LelyBorderWidth,
  LelyFontFamily,
  LelyFontSize,
  LelyFontWeight,
  LelyLetterSpacing,
  LelyLineHeight,
  LelyOpacity,
  LelySpacing,
} from '@lely/tokens/enums';
import buildLelyPalette, {
  LelyBackgroundPalette,
  LelyBorderPalette,
  LelyTextPalette,
} from './theme/palette';
import lelyTypography, {
  LelyTypographyVariants,
  LelyVariantOverrides,
} from './theme/typography';

declare module '@mui/material/styles' {
  interface Theme {
    lelySpacing: typeof LelySpacing;
    lelyLineHeight: typeof LelyLineHeight;
    lelyFontFamily: typeof LelyFontFamily;
    lelyFontSize: typeof LelyFontSize;
    lelyOpacity: typeof LelyOpacity;
    lelyBorderRadius: typeof LelyBorderRadius;
  }

  interface ThemeOptions {
    lelySpacing?: typeof LelySpacing;
    lelyLineHeight?: typeof LelyLineHeight;
    lelyFontFamily?: typeof LelyFontFamily;
    lelyFontSize?: typeof LelyFontSize;
    lelyOpacity?: typeof LelyOpacity;
    lelyBorderRadius?: typeof LelyBorderRadius;
  }

  interface Palette {
    border: LelyBorderPalette;
  }

  interface PaletteOptions {
    border?: Partial<LelyBorderPalette>;
  }

  interface TypeText extends LelyTextPalette {}
  interface TypeBackground extends LelyBackgroundPalette {}

  interface TypographyVariants extends LelyTypographyVariants {}
  interface TypographyVariantsOptions extends Partial<LelyTypographyVariants> {}
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides extends LelyVariantOverrides {}
}

declare module '@mui/material' {
  interface CircularProgressPropsColorOverrides {
    default: true;
  }
}

declare module '@mui/material/styles' {
  interface Duration {
    lelyTransition: number;
  }
}

const drawerZIndex = 9999999;

let LelyMuiTheme = createTheme({
  palette: buildLelyPalette(),
  typography: lelyTypography,
  spacing: parsePx(LelySpacing.XS, 4),
  lelySpacing: LelySpacing,
  lelyLineHeight: LelyLineHeight,
  lelyFontFamily: LelyFontFamily,
  lelyFontSize: LelyFontSize,
  lelyOpacity: LelyOpacity,
  lelyBorderRadius: LelyBorderRadius,
  shape: {
    borderRadius: parsePx(LelyBorderRadius.SM, 4),
  },
  transitions: {
    duration: {
      lelyTransition: 300,
    },
  },

  zIndex: {
    drawer: drawerZIndex,
    modal: drawerZIndex + 1,
  },
});

LelyMuiTheme = createTheme(LelyMuiTheme, {
  components: {
    ...getMuiComponents(LelyMuiTheme),
  },
});

export { lelyTokenPrimitives };
export default LelyMuiTheme;
